import { FormFileType } from '@/views/applications/types';

export const APP_BASE_INFO = {
  appName: '应用名',
  appDescription: '描述',
  hasVOIP: '是否VOIP推送',
  appId: '应用Id',
  appKey: '应用Key',
};

export const SUB_KEYS = {
  pushTitle: '推送标题',
  appKey: 'AppKey',
  appSecret: 'AppSecret',
  appId: 'AppId',
  iosSound: '声音文件',
  bundleId: '包名',
  androidSilentNoticeChannelId:'静默频道',
  androidNormalNoticeChannelId:'普通频道'
};

export const CONFIG_TYPES = new Map([
  ['oneSignalConfig', 'OneSignal配置'],
  ['jConfig', '极光推送配置'],
  ['hmsConfig', '华为HMS推送配置'],
  ['miConfig', '小米推送配置'],
  ['oppoConfig', 'OPPO推送配置'],
  ['vivoConfig', 'VIVO推送配置'],
  ['callbackUrls', '回调配置'],
]);


export const PUSH_TYPES = [
  { label: 'IOS普通推送', disabled: false, value: 'iosOrdinary' },
  { label: 'Android普通推送', disabled: false, value: 'androidOrdinary' },
];

export const PUSH_VOIP_TYPES = [
  { label: 'IOS普通推送', disabled: false, value: 'iosOrdinary' },
  { label: 'IOS VOIP推送', disabled: false, value: 'iosVOIP' },
  { label: 'Android普通推送', disabled: false, value: 'androidOrdinary' },
];

export const COMMON_PUSH = [{ label: '普通推送', disabled: false, value: 'commonPush' }];

export const NOTIFICATION_TYPES = [{ label: '回调API', disabled: false, value: 'notificationApi' }];

export const MI_PUSH = [{ label: '普通推送', disabled: false, value: 'miPush' }];

export const OPPO_PUSH = [{ label: '普通推送', disabled: false, value: 'oppoPush' }];

export const VIVO_PUSH = [{ label: '普通推送', disabled: false, value: 'vivoPush' }];

export const PUSH_TYPE_MAP = {
  iosOrdinary: 'IOS普通推送',
  iosVOIP: 'IOS VOIP推送',
  androidOrdinary: 'Android普通推送',
  androidVOIP: 'Android VOIP推送',
  commonPush: '普通推送',
  miPush: '普通推送',
  oppoPush: '普通推送',
  vivoPush: '普通推送',
  notificationApi: '回调API',
};

// 配置映射表
export const CONFIG_MAPPING: Record<string, Record<string, FormFileType[]>> = {
  iosOrdinary: {
    fields: [
      { label: '推送标题', model: 'pushTitle', placeholder: '请输入标题' },
      { label: 'AppId', model: 'appId', placeholder: '请输入AppId', ruler: [{ required: true, message: '请输入AppId', trigger: 'blur' }] },
      { label: 'AppKey', model: 'appKey', placeholder: '请输入AppKey', ruler: [{ required: true, message: '请输入AppKey', trigger: 'blur' }] },
      { label: '声音文件', model: 'iosSound', placeholder: '请输入推送声音文件' },
      { label: '包名', model: 'bundleId', placeholder: '请输入应用包名', ruler: [{ required: true, message: '请输入应用包名', trigger: 'blur' }] },
    ],
  },
  iosVOIP: {
    fields: [
      { label: '推送标题', model: 'pushTitle', placeholder: '请输入标题' },
      { label: 'AppId', model: 'appId', placeholder: '请输入AppId', ruler: [{ required: true, message: '请输入AppId', trigger: 'blur' }] },
      { label: 'AppKey', model: 'appKey', placeholder: '请输入AppKey', ruler: [{ required: true, message: '请输入AppKey', trigger: 'blur' }] },
      { label: '推送声音文件名', model: 'iosSound', placeholder: '请输入推送声音文件名' },
      { label: '包名', model: 'bundleId', placeholder: '请输入应用包名', ruler: [{ required: true, message: '请输入应用包名', trigger: 'blur' }] },
    ],
  },
  androidOrdinary: {
    fields: [
      { label: '推送标题', model: 'pushTitle', placeholder: '请输入标题' },
      { label: 'AppId', model: 'appId', placeholder: '请输入AppId', ruler: [{ required: true, message: '请输入AppId', trigger: 'blur' }] },
      { label: 'AppKey', model: 'appKey', placeholder: '请输入AppKey', ruler: [{ required: true, message: '请输入AppKey', trigger: 'blur' }] },
      { label: '包名', model: 'bundleId', placeholder: '请输入应用包名', ruler: [{ required: true, message: '请输入应用包名', trigger: 'blur' }] },
      { label: '静默频道', model: 'androidSilentNoticeChannelId', placeholder: '请输入静默通知频道Id'},
      { label: '普通频道', model: 'androidNormalNoticeChannelId', placeholder: '请输入普通通知频道Id'},
    ],
  },
  androidVOIP: {
    fields: [
      { label: '推送标题', model: 'pushTitle', placeholder: '请输入标题' },
      { label: 'AppId', model: 'appId', placeholder: '请输入AppId', ruler: [{ required: true, message: '请输入AppId', trigger: 'blur' }] },
      { label: 'AppKey', model: 'appKey', placeholder: '请输入AppKey', ruler: [{ required: true, message: '请输入AppKey', trigger: 'blur' }] },
      { label: '包名', model: 'bundleId', placeholder: '请输入应用包名', ruler: [{ required: true, message: '请输入应用包名', trigger: 'blur' }] },
      { label: '静默频道', model: 'androidSilentNoticeChannelId', placeholder: '请输入静默通知频道Id'},
      { label: '普通频道', model: 'androidNormalNoticeChannelId', placeholder: '请输入普通通知频道Id'},
    ],
  },
  commonPush: {
    fields: [
      { label: '推送标题', model: 'pushTitle', placeholder: '请输入标题' },
      { label: 'AppId', model: 'appId', placeholder: '请输入AppId', ruler: [{ required: true, message: '请输入AppId', trigger: 'blur' }] },
      { label: 'AppKey', model: 'appKey', placeholder: '请输入AppKey', ruler: [{ required: true, message: '请输入AppKey', trigger: 'blur' }] },
      { label: '包名', model: 'bundleId', placeholder: '请输入应用包名', ruler: [{ required: true, message: '请输入应用包名', trigger: 'blur' }] },
    ],
  },
  miPush: {
    fields: [
      { label: '推送标题', model: 'pushTitle', placeholder: '请输入标题' },
      { label: 'AppSecret', model: 'appSecret', placeholder: '请输入AppSecret', ruler: [{ required: true, message: '请输入AppSecret', trigger: 'blur' }] },
      { label: '包名', model: 'bundleId', placeholder: '请输入应用包名', ruler: [{ required: true, message: '请输入应用包名', trigger: 'blur' }] },
    ],
  },
  oppoPush: {
    fields: [
      { label: '推送标题', model: 'pushTitle', placeholder: '请输入标题' },
      { label: 'AppKey', model: 'appKey', placeholder: '请输入AppKey', ruler: [{ required: true, message: '请输入AppKey', trigger: 'blur' }] },
      { label: 'AppSecret', model: 'appSecret', placeholder: '请输入AppSecret', ruler: [{ required: true, message: '请输入AppSecret', trigger: 'blur' }] },
      { label: '包名', model: 'bundleId', placeholder: '请输入应用包名', ruler: [{ required: true, message: '请输入应用包名', trigger: 'blur' }] },
    ],
  },
  vivoPush: {
    fields: [
      { label: '推送标题', model: 'pushTitle', placeholder: '请输入标题' },
      { label: 'AppId', model: 'appId', placeholder: '请输入AppId', ruler: [{ required: true, message: '请输入AppId', trigger: 'blur' }] },
      { label: 'AppKey', model: 'appKey', placeholder: '请输入AppKey', ruler: [{ required: true, message: '请输入AppKey', trigger: 'blur' }] },
      { label: 'AppSecret', model: 'appSecret', placeholder: '请输入AppSecret', ruler: [{ required: true, message: '请输入AppSecret', trigger: 'blur' }] },
      { label: '包名', model: 'bundleId', placeholder: '请输入应用包名', ruler: [{ required: true, message: '请输入应用包名', trigger: 'blur' }] },
    ],
  },
  notificationApi: {
    fields: [
      { label: '推送标题', model: 'pushTitle', placeholder: '请输入标题' },
      { label: '用户在线状态回调', model: 'onlineStatus', placeholder: '请输入回调地址' },
      { label: '语音通话状态回调', model: 'voiceStatus', placeholder: '请输入回调地址' },
    ],
  },
};
